import { adminLayoutWrap } from '@middlewares';
import { Flag } from '@utils';
import { Permission } from '@common/utils/admin_permissions';
import SystemLogPage from './pages/SystemLogPage';

export const routes = {
  SystemLog: {
    label: 'Audit Log',
    path: '/audit-log',
    page: adminLayoutWrap({
      children: <SystemLogPage />,
      flag: Flag.SHOW_SYSLOG,
      permissions: [Permission.SYSLOG_READ],
    }),
  },
};
